module.exports = __webpack_public_path__ + "static/media/iconNotificacion.72bbcd30.svg";